<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="reset"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center mt-2"> 
        <h5 class="mb-0 text-primary"><i class="fa fa-graduation-cap  text-primary"></i> SSC-Pass Students</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class=" col-md-3">
          <label class="form-label">Batch<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.Batch">
            <option selected=""></option>
            <option value="1">Batch 1</option>
            <option value="2">Batch 2</option>
            <option value="3">Batch 3</option>
            <option value="1">Batch 4</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Year<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.Year">
            <option selected=""></option>
            <option value="1">2024-2025</option>
            <option value="2">2023-2024</option>
            <option value="3">2022-2023</option>
            <option value="1">2021-2022</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Class :</label>
          <input type="text" class="form-control form-control-sm" placeholder="Class 10" value="Class 10" v-model="Obj.Class">
        </div>
        <div class="col-md-9 text-end mt-2">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i class="fa fa-save text-white"></i> Save</button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
  <div class="row">
    <div class="col-md-8 table-responsive mt-2">
      <table id="example" class="table table-striped table-bordered dataTable w-100" role="grid"
        aria-describedby="example_info">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Batch</th>
            <th>Year</th>
            <th>Class</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in List" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.Batch }}</td>
            <td>{{ item.Year }}</td>
            <td>{{$store.state.Classes.find(cls => cls._id == item.Class)?.name || ''}}</td>
            <td>
              <i @click="Obj = { ...item }" class="fa fa-pencil-square-o col-3 fs-5 me-3" role="button"
                aria-hidden="true"></i>
              <i @click="delObj = item" class="fa fa-trash col-3 text-danger fs-5" role="button" data-bs-toggle="modal"
                data-bs-target="#staticBackdrop" aria-hidden="true"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal fade" id="studentDetailsModal" tabindex="-1" aria-labelledby="studentDetailsModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Student Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-md-6 d-flex align-items-end ms-auto">
              <label class="form-label me-2">Search:</label>
              <input type="text" class="form-control w-50" id="searchInput">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 table-responsive mt-2 overflow-auto" style="max-height: 200px;">
              <table id="example" class="table table-striped table-bordered dataTable w-100" role="grid"
                aria-describedby="example_info">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Roll No</th>
                    <th>Name</th>
                    <th>Class</th>
                    <th>Section</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>20691A0502</td>
                    <td>Rahul</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>20691B0503</td>
                    <td>Sameer</td>
                    <td>Class 10</td>
                    <td>B</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>20691A0502</td>
                    <td>Ramya</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>20691D0502</td>
                    <td>Aditya</td>
                    <td>Class 10</td>
                    <td>D</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>20691C0504</td>
                    <td>Amit</td>
                    <td>Class 10</td>
                    <td>C</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>20691A0505</td>
                    <td>Priya</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>20691B0506</td>
                    <td>Neha</td>
                    <td>Class 10</td>
                    <td>B</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>20691D0507</td>
                    <td>Arjun</td>
                    <td>Class 10</td>
                    <td>D</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>20691C0508</td>
                    <td>Kiran</td>
                    <td>Class 10</td>
                    <td>C</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>20691A0509</td>
                    <td>Meena</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>20691A0502</td>
                    <td>Rahul</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>20691B0503</td>
                    <td>Sameer</td>
                    <td>Class 10</td>
                    <td>B</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>20691A0502</td>
                    <td>Ramya</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>20691D0502</td>
                    <td>Aditya</td>
                    <td>Class 10</td>
                    <td>D</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>20691C0504</td>
                    <td>Amit</td>
                    <td>Class 10</td>
                    <td>C</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>20691A0505</td>
                    <td>Priya</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>20691B0506</td>
                    <td>Neha</td>
                    <td>Class 10</td>
                    <td>B</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>20691D0507</td>
                    <td>Arjun</td>
                    <td>Class 10</td>
                    <td>D</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>20691C0508</td>
                    <td>Kiran</td>
                    <td>Class 10</td>
                    <td>C</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>20691A0509</td>
                    <td>Meena</td>
                    <td>Class 10</td>
                    <td>A</td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Batch" @delRecord="delRecord"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { useStore } from 'vuex'

const store = useStore()
console.log(store)
  const  Obj = ref( {Batch: "", Year: "", Class: "", })
  const  List= ref([])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
  const save= async() => {
      const fields = {
        Batch: {
          value: Obj.value.Batch,
          validators: [isRequired],
        },
        Year: {
          value: Obj.value.Year,
          validators: [isRequired],
        },

      };
      errors.value = validateForm(fields);

      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/SSCPass${url}`, Obj.value)
          .then((response) => {
            loadData();
            reset();
            msgObj.value = { msg: `SSCPass ${msg} Successfuly`, role: "success", show: true, };
            console.log(response);
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset= async()=> {
      Obj.value = { Batch: "", Year: "", Class: "", };
      msgObj.value = { msg: "", role: "", show: false, };
       errors.value ={};
    }
    const loadData= async()=> {
      await api.get('/SSCPass/all') .then((response) => { List.value = response.data; });
    }
    const delRecord=async() => {
      await api.delete(`/SSCPass/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "SSCPass Deleted Successfuly.", role: "danger", show: true, };
        });
    }
 onMounted(() => { loadData() })
</script>
